import type { ReactNode } from 'react';
import { Cloud } from 'lucide-react';
import './desktop-agent.css';

/** Cloud context uses the Local Agent presentation without local workspace controls. */
export function WebAgentControls({ brandSelector }: { brandSelector?: ReactNode }) {
  return <div className="desktop-agent-controls" data-testid="web-agent-controls">
    <div className="desktop-agent-context">
      <span className="desktop-agent-computer" title="Your agent works in Admoji"><Cloud size={16} aria-hidden="true" />Admoji</span>
      {brandSelector && <div className="desktop-agent-brand" aria-label="Brand"><span className="desktop-agent-brand-label">Brand</span>{brandSelector}</div>}
    </div>
  </div>;
}
